import React from "react";
import { Linkedin, Mail, ArrowUp } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-bgdark text-white border-t border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-7">
            <p className="mono-label">Get in touch — directly</p>
            <a
              data-testid="footer-email-link"
              href="mailto:sabari@sabariconsultant.com"
              className="block font-display uppercase tracking-tighter leading-[0.9] mt-4 hover:text-accent-amber transition-colors break-words"
              style={{ fontSize: "clamp(2rem, 6vw, 5.5rem)" }}
            >
              sabari<span className="text-accent-amber">@</span>sabariconsultant.com
            </a>
            <div className="mt-6 flex flex-col gap-1.5 font-mono text-sm text-white/55">
              <a
                data-testid="footer-email-secondary"
                href="mailto:sabariconsultantsblr@gmail.com"
                className="hover:text-accent-amber transition-colors"
              >
                ↳ sabariconsultantsblr@gmail.com
              </a>
              <a
                data-testid="footer-email-tertiary"
                href="mailto:sgeshwar@gmail.com"
                className="hover:text-accent-amber transition-colors"
              >
                ↳ sgeshwar@gmail.com (founder)
              </a>
            </div>
          </div>
          <div className="lg:col-span-5 lg:pl-10 lg:border-l border-white/15 flex flex-col gap-8">
            <div>
              <p className="mono-label">Office</p>
              <p className="mt-2 text-sm text-white/75 leading-relaxed">
                M/s Sabari Consultant
                <br />
                Proprietorship · MSME Registered
                <br />
                Bengaluru, Karnataka, India
              </p>
              <p className="mt-3 font-mono text-[11px] text-white/55 leading-relaxed">
                Proprietor <span className="text-white/85">Mrs. Sindhu Sabari</span>
                <br />
                GSTIN <span className="text-white/85">29LDPPS1020K1ZY</span>
                <br />
                UDYAM <span className="text-white/85">KR-03-0707078</span>
              </p>
            </div>
            <div>
              <p className="mono-label">Hours</p>
              <p className="mt-2 text-sm text-white/75">
                Mon — Sat · 09:00 – 19:00 IST
              </p>
              <p className="text-xs text-white/40 mt-1">
                Site visits arranged across South India &amp; Pan-India remote.
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 grid md:grid-cols-3 gap-6 items-center">
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_sabari-safety/artifacts/aaa6fa1x_WhatsApp%20Image%202026-06-07%20at%209.05.22%20PM.jpeg"
              alt="Sabari Consultant"
              className="w-10 h-10 object-contain bg-white p-0.5"
            />
            <span className="font-display uppercase tracking-tight text-sm leading-none">
              Sabari<span className="text-accent-red">.</span>Consultant
              <span className="block font-mono text-[9px] tracking-[0.22em] text-white/45 mt-1 normal-case">
                Consult · Train · Protect
              </span>
            </span>
          </div>

          <div className="flex items-center justify-start md:justify-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-white/50">
            © {year} · All rights reserved
          </div>

          <div className="flex items-center justify-start md:justify-end gap-3">
            <a
              data-testid="footer-linkedin"
              href="https://www.linkedin.com/in/sabari-eshwaran-ehs-manager"
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-white hover:text-black transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin size={16} />
            </a>
            <a
              data-testid="footer-email-icon"
              href="mailto:sabari@sabariconsultant.com"
              className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-white hover:text-black transition-colors"
              aria-label="Email"
            >
              <Mail size={16} />
            </a>
            <button
              data-testid="footer-back-to-top"
              onClick={() =>
                window.scrollTo({ top: 0, behavior: "smooth" })
              }
              className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-accent-amber hover:border-accent-amber hover:text-black transition-colors"
              aria-label="Back to top"
            >
              <ArrowUp size={16} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
